<template>
  <div
    :class="classes"
  >
    <table
      v-once
      :id="tableId"
      ref="table"
      :class="className"
      cellpadding="0"
    >
      <thead class="thead-dark">
        <tr>
          <th
            v-for="(field, i) in options.columns"
            :key="i"
            :class="field.className"
          >
            <slot
              :name="`HEAD_${field.name}`"
              :field="field"
              :i="i"
            >
              <div v-html="field.title" />
            </slot>
          </th>
        </tr>
      </thead>
      <tbody/>
      <tfoot id="footR"></tfoot>

    </table>
  </div>
</template>

<script>
let myUniqueId = 1

const compiler = require('vue-template-compiler')
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'VdtnetTable',
  props: {
    /**
     * The table id
     *
     * @type String
     */
    id: {
      type: String,
      default: null
    },
    /**
     * The table id
     *
     * @type String
     */
    url: {
      type: String,
      default: null
    },
    /**
     * Set the container classes.
     *
     * @type String
     */
    containerClassName: {
      type: String,
      default: 'table-responsive d-print-inline'
    },
    /**
     * Set the table classes you wish to use, default with bootstrap4
     * but you can override with: themeforest, foundation, etc..
     *
     * @type String
     */
    className: {
      type: String,
      default: 'table mt-0 table-striped table-borderless nowrap w-100'
    },
    /**
     * the options object: https://datatables.net/manual/options
     *
     * @type Object
     */
    opts: {
      type: Object
    },
    /**
     * List all fields to be converted to opts columns
     *
     * @type Object
     */
    fields: {
      type: Object
    },
    /**
     * Pass in DataTables.Net jQuery to resolve any conflict from
     * multiple jQuery loaded in the browser
     *
     * @type Object
     */
    jquery: {
      type: Object
    },
    /**
     * Pass in Vue to resolve any conflict from multiple loaded
     *
     * @type Object
     */
    vue: {
      type: Object
    },
    /**
     * The select-checkbox column index (start at 1)
     * Current implementation require datatables.net-select
     *
     * @type Number
     */
    selectCheckbox: {
      type: Number
    },
    /**
     * Provide custom local data loading.  Warning: this option has not been
     * thoroughly tested.  Please use ajax and serverSide instead.
     *
     * @type Function
     */
    dataLoader: {
      type: Function
    },
    /**
     * true to hide the footer of the table
     *
     * @type Boolean
     */
    hideFooter: {
      type: Boolean
    },
    /**
     * The details column configuration of master/details.
     *
     * @type {Object}
     */
    details: {
      type: Object
    }
  },
  data() {
    // initialize defaults
    return {
      tableId: null,
      fieldsNew: {},
      options: {
/*eslint-disable */
        dom: "tr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
/*eslint-enable */
        columns: [],
        language: {
          emptyTable:   "La tabella non contiene informazioni",
  				info:           "Visualizzazione da _START_ a _END_ di _TOTAL_ righe totali",
  				infoEmpty:      "Visualizzazione da  0 a 0 di 0 righe totali",
  				infoFiltered:   "(dati filtrati da _MAX_ record totali)",
  				lengthMenu:     " _MENU_ Mostra righe",
  				loadingRecords: "Sto caricando ...",
  				processing:     "Processing...",
  				search:         "Cerca:",
  				searchPlaceholder: "Scrivi e premi INVIO...",
  				zeroRecords:    "Nessun record trovato",
  				paginate: {
  					first:      "Prima",
  					last:       "Ultima",
  					next:       "Successiva",
  					previous:   "Precedente",
          }
        },
        lengthMenu: [ [ -1, 5, 10, 15, 20], ['All', 5, 10, 15, 20 ] ],
        pageLength: 1000,
        buttons: []  // remove any button defaults
      },
      dataTable: null,
      vdtnet: this
    }
  },
  computed: {
    jq() {
      return this.jquery || window.jQuery
    },
    myVue() {
      return Vue || window.Vue
    },
    classes() {
      const that  = this
      let classes = `${that.containerClassName} vdtnet-container`
      if (this.hideFooter) {
        classes += ' hide-footer'
      }

      return classes
    }
  },
  created() {
    const that = this
    const jq   = that.jq
    that.tableId = that.id || `vdtnetable${myUniqueId++}`

    // allow user to override default options
    if (that.opts) {
      that.options = jq.extend({}, that.options, that.opts)
    }
  },
  beforeMount(){
    const url = this.url

    //this.loadRegistrationData()

  },
  async mounted() {
    const that   = this
    const jq     = that.jq
    const $el    = jq(that.$refs.table)
    const orders = []

    let startCol = 0
    let icol     = 0

    // if fields are passed in, generate column definition
    // from our custom fields schema
    this.$log( 'I AM START WAITIIIIING' )
    //await this.loadRegistrationData()
    this.$log( 'OK FINISH WAITIIIIING' )
    if (that.fieldsNew) {
      var fields = that.fields
      let cols = that.options.columns

      for (let k in fields) {
        var field = fields[k]
        field.name  = field.name || k

        // disable search and sort for local field
        if (field.isLocal) {
          field.searchable = false
          field.sortable  = false
        }

        // generate
        let col = {
          title:      field.label || field.name,
          data:       field.data || field.name,
          width:      field.width,
          name:       field.name,
          className:  field.className,
          index:      field.index || (icol + 1)
        }

        if (field.width) {
          col.width = field.width
        }

        if (field.hasOwnProperty('defaultContent')) {
          col.defaultContent = field.defaultContent
        }

        if (field.hasOwnProperty('sortable')) {
          col.orderable = field.sortable
        }

        if (field.hasOwnProperty('visible')) {
          col.visible = field.visible
        }

        if (field.hasOwnProperty('searchable')) {
          col.searchable = field.searchable
        }

        if (field.template || that.$scopedSlots[field.name]) {
          field.render = that.compileTemplate(field, that.$scopedSlots[field.name])
        }

        if (field.render) {
          if (!field.render.templated) {
            let myRender = field.render
            field.render = function() {
              return myRender.apply(that, Array.prototype.slice.call(arguments))
            }
          }

          col.render = field.render
        }

        // this.$log(col)
        cols.push(col)

        if (field.defaultOrder) {
          orders.push([icol, field.defaultOrder])
        }

        icol++
      }

      // sort columns
      cols = cols.sort((a, b) => a.index - b.index)
    }

    // apply orders calculated from above
    that.options.order = that.options.order || orders

    if (that.selectCheckbox) {
      that.selectCheckbox = that.selectCheckbox || 1

      // create checkbox column
      var col = {
        orderable: false,
        searchable: false,
        name: '_select_checkbox',
        className: 'select-checkbox d-print-none',
        data: null,
        defaultContent: '',
        title: '<input type="checkbox" class="select-all-checkbox d-print-none">',
        index: (that.selectCheckbox - 1)
      }
      that.options.columns.splice(that.selectCheckbox - 1, 0, col)

      // this.$log(that.options.columns)
      that.options.select = jq.extend(
        that.options.select || {},
        {
          style: 'os',
          selector: 'td.select-checkbox'
        }
      )

      if (that.selectCheckbox === 1) {
        startCol++
      }
    }

    // handle master details
    if (that.details) {
      that.details.index = that.details.index || 1

      // create details column
      const col = {
        orderable: false,
        searchable: false,
        name: '_details_control',
        className: 'details-control d-print-none',
        data: null,
        defaultContent: that.details.icons || '<span class="details-plus" title="Show details">+</span><span class="details-minus" title="Hide details">-</span>',
        index: (that.details.index - 1)
      }
      that.options.columns.splice(that.details.index - 1, 0, col)

      if (that.details.index === 1) {
        startCol++
      }
    }

    if (startCol > 0) {
      if (that.options.order) {
        that.options.order.forEach((v) => {
          v[0] += startCol
        })
      } else {
        that.options.order = [[startCol, 'asc']]
      }
    }

    // handle local data loader
    if (that.dataLoader) {
      delete that.options.ajax
      that.options.serverSide = false
    }

    // you can access and update the that.options and $el here before we create the DataTable



    that.$emit('table-creating', that, $el)

    that.dataTable = $el.DataTable(that.options)


    if (that.selectCheckbox) {
      // handle select all checkbox
      $el.on('click', 'th input.select-all-checkbox', (e) => {
        if(jq(e.target).is(':checked')) {
          that.dataTable.rows().select()
        } else {
          that.dataTable.rows().deselect()
        }
      })

      // handle individual row select events
      that.dataTable.on('select deselect', () => {
        const $input = $el.find('th input.select-all-checkbox')
        if (that.dataTable.rows({
            selected: true
          }).count() !== that.dataTable.rows().count()) {
          jq('th.select-checkbox').removeClass('selected')
          $input.attr('checked', false)
        } else {
          jq('th.select-checkbox').addClass('selected')
          $input.attr('checked', true)
        }
        // TODO: that.$emit the selected row?
      })
    }

    // wire up edit, delete, and/or action buttons
    $el.on('click', '[data-action]', (e) => {
      e.preventDefault()
      e.stopPropagation()
      let target = jq(e.target)
      let action  = target.attr('data-action')
      while(!action) {
        // don't let it propagate outside of container
        if (target.hasClass('vdtnet-container') ||
          target.prop('tagName') === 'table') {
          // no action, simply exit
          return
        }
        target = target.parent()
        action = target.attr('data-action')
      }

      // only emit if there is action
      if (action) {
        // detect if row action
        this.$log(action)

        let tr = target.closest('tr')

        if ( action == 'link' ){

          // BIND ROUTER PATH AND URL **********************************************************************************

          var par = that.url
          par = par.replace(process.env.ROOT_API + 'api/loadProducts?id=', "");



          if (tr.attr('role') !== 'row') {
            tr = tr.prev()
          }
          const row1  = that.dataTable.row(tr)
          const data1 = row1.data()


          this.$router.push({
            name: 'addDocuments',
            params: { id: par, data: data1 }
          })

          // BIND ROUTER PATH AND URL **********************************************************************************

        }

        if (tr) {
          if (tr.attr('role') !== 'row') {
            tr = tr.prev()
          }
          const row  = that.dataTable.row(tr)
          const data = row.data()
          that.$emit(action, data, row, tr, target)
        } else {
          // not a row click, must be other kind of action
          // such as bulk, csv, pdf, etc...
          if ( action == 'link' ){

          }else{
            that.$emit(action, null, null, null, target)
          }


        }
      }
    })

    // handle master/details
    if (that.details) {
      // default to render function
      let renderFunc = that.details.render

      // must be string template
      if (that.details.template || that.$scopedSlots['_details']) {
        renderFunc = that.compileTemplate(that.details, that.$scopedSlots['_details'])
      } else if (renderFunc) {
        renderFunc = function() {
          return that.details.render.apply(that, Array.prototype.slice.call(arguments))
        }
      }

      // handle master/details
      // Add event listener for opening and closing details
      $el.on('click', 'td.details-control', (e) => {
        e.preventDefault()
        e.stopPropagation()
        const target = jq(e.target)
        let tr       = target.closest('tr')
        if (tr.attr('role') !== 'row') {
          tr = tr.prev()
        }
        const row = that.dataTable.row( tr )
        if ( row.child.isShown() ) {
          // This row is already open - close it
          row.child.hide()
          tr.removeClass('master')
        }
        else {
          // Open this row
          const data = row.data()
          row.child( renderFunc(data, 'child', row, tr) ).show()
          tr.addClass('master')
        }
      })


    }

    // handle master/Search on specific field
    // Add event listener for all search fields
    $el.on('keyup', '.footSearch', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const target = jq(e.target)
      if (e.keyCode == 13) {
        this.$log('Enter was pressed');
        var fieldK = jq(target).data('field')
        this.$log(fieldK);
        this.$log(that.dataTable)
        that.dataTable.columns( fieldK ).search( target[0].value )
        that.dataTable.draw()
      }
    })

    that.$emit('table-created', that)

    // finally, load data
    if (that.dataLoader) {
      that.reload()
    }

    this.$log( 'BEFORE CREATE FOOTER ################################' )

      // CREATE FOOTER
      jq('.dataTable thead tr').each( function (e) {
          var elemX = this
          if ( jq(elemX).html() != '' ){
            var k = 0
            jq(elemX).children('th').each( function (e) {
              if ( k != 500  ){
                var title = jq(this).text();
                var style = jq(this).attr("style");
                this.$log(title)

                jq('thead').append('<th><input class="footSearch p-0 m-0 center" type="text" data-field="'+k+'" rows="3" style="'+style+'min-width:70px;" placeholder="Cerca" /></th>')
              }else{
                jq('thead').append('<th></th>')
              }
              k++
            })
          }
      } );

    this.$log( 'END CREATE FOOTER ################################' )

  },
  beforeDestroy() {
    const that = this
    if (that.dataTable) {
      that.dataTable.destroy(true)
    }

    that.dataTable = null
  },
  methods: {

    async loadRegistrationData(){
      var _vue = this
      var fields = {}

      var data = { getFieldsNames: true }
      var l = this.url

      var fields = {
        confirmed: {
          label: 'Esito',
          sortable: true,
          searchable: false,
          render: (data, display ,row) => {

            if ( data == 0 ){
              return ' In Verifica '
            }

            if ( data == 1 ){
             return ' Approvato '
            }

             if ( data == 2 ){
              return ' Respinto <br/> <small> ' +row.confirm_info+ '</small>'
             }


          }
        },

        azienda: { label: 'Azienda', sortable: true, searchable: true },
        partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
        codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

        barcode: {
          label: 'Matricola',
          sortable: true,
          searchable: true,
          render: (data, display ,row) => {
            return ' <a class="simpleLink green" target="_blank" href="'+ row.image +'"> <small>'+ data +'</small> </a> '
          }
        },
       product: { label: 'Prodotto', sortable: true, searchable: true },

       invoice_number: {
         label: 'Prova d`acquisto',
         sortable: true,
         searchable: true,
         render: (data, display ,row) => {
           return ' <a class="simpleLink green" target="_blank" href="'+ row.invoice +'"> <small>'+ data +'</small> </a> '
         }
       },

       invoice_date: { label: 'Data Doc.', sortable: true, searchable: true },


      }

      _vue.fieldsNew = fields


    },


    /**
     * Vue.compile a template string and return the compiled function
     *
     * @param  {Object} object with template property
     * @param  {Object} the slot
     * @return {Function}          the compiled template function
     */
    compileTemplate(field, slot) {
      const that = this
      const jq   = that.jq
      const vue  = Vue
      const res  = Vue.compile(`<div>${field.template || ''}</div>`)


      const renderFunc = (data, type, row, meta) => {
        let myRender = res.render

        if (slot) {
          this.$log(slot)
          myRender = (createElement) => {
            return createElement('div', [
              slot({
                data: data,
                type: type,
                row: row,
                meta: meta,
                vdtnet: that,
                def: field,
                comp: that.$parent
              })
            ])
          }
        }

        const comp = new vue({
          data: {
            data: data,
            type: type,
            row: row,
            meta: meta,
            vdtnet: that,
            def: field,
            comp: that.$parent
          },
          render: myRender,
          staticRenderFns: res.staticRenderFns
        }).$mount()
        return jq(comp.$el).html()
      }


      renderFunc.templated = true

      return renderFunc
    },
    /**
     * Set table data array that was loaded from somewhere else
     * This method allow for local setting of data; though, it
     * is recommended to use ajax instead of this.
     *
     * @param {Array} data   the array of data
     * @return {Object}            the component
     */
    setTableData(data) {
      const that = this
      if (data.constructor === Array) {
        that.dataTable.clear().rows.add(data)
        that.dataTable.draw(false)
        that.dataTable.columns.adjust()
      }
      return that
    },
    /**
     * pass through reload method
     *
     * @param  {Boolean}  resetPaging true to reset current page position
     * @return {Object}            the component
     */
    reload(resetPaging = false) {
      const that = this
      if (that.dataLoader) {
        // manual data loading
        that.dataLoader((data) => {
          if (data && !data.data) {
            data = { data: data }
          }
          that.setTableData( data.data )

          that.$emit('reloaded', data, that)
        })
      } else {
        that.dataTable.ajax.reload( (data) => { that.$emit('reloaded', data, that) } , resetPaging )
      }

      return that
    },
    search(value) {
      const that = this
      that.dataTable.search( value ).draw()

      return that
    },
    setPageLength(value) {
      const that = this
      that.dataTable.page.len( value )

      return that.reload()
    },
    getServerParams() {
      if (this.dataLoader) {
        return {}
      }

      return this.dataTable.ajax.params()
    }
  }
}
</script>
<style>
.select-checkbox, .select-all-checkbox {
  cursor: pointer;
}
.vdtnet-footer .dataTables_length {
  padding-top: 6px;
  padding-right: 10px;
}
.vdtnet-footer .dataTables_length, .vdtnet-footer .dataTables_paginate {
  float: right;
}
.hide-footer .vdtnet-footer {
  display: none;
}

.master .details-plus
{
  cursor: pointer;
  display: none;
}
.details-minus
{
  cursor: pointer;
  display: none;
}
.master .details-minus
{
  cursor: pointer;
  display: inline;
}
.details-control {
  cursor: pointer;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/table/productsTable.vue